/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <JobOffers {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { Section, CmsImage } from "@bw/bits"
import { JobOffers as JobOffersModule } from "@bw/modules"
import { useStaticQuery, graphql } from "gatsby"
import shuffle from "../../../utils/shuffle"
import { useTranslation } from "react-i18next"

const Jobs = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  anchor,
}) => {
  const { t } = useTranslation()
  const { allCollectionJobs, siteSearchIndex } = useStaticQuery(graphql`
    query SearchJobQuery {
      allCollectionJobs {
        nodes {
          title
          occupancyRate
          url
          slug
          isRelatedToAdministration
          jobType {
            title
          }
          pharmacy {
            state {
              value
            }
            city
            images {
              localImage {
                childImageSharp {
                  gatsbyImageData(width: 350, height: 175)
                }
              }
            }
          }
        }
      }
    }
  `)

  const shuffled = React.useMemo(() => {
    const jobs = allCollectionJobs.nodes.map(job => {
      let excerpt, city, state, image

      switch (true) {
        case job.isRelatedToAdministration === true:
          excerpt = "Bremblens"
          city = "Bremblens"
          state = "vd"
          break

        case !!job.pharmacy:
          excerpt = job.pharmacy.city
          city = job.pharmacy.city
          state = job.pharmacy.state?.value

          if (job.pharmacy.images && job.pharmacy.images[0]) {
            image = <CmsImage src={job.pharmacy.images[0]} alt="" />
          }
          break

        default:
          excerpt = null
          city = null
          state = null
      }

      return {
        to: job.slug,
        suptitle: t("job.occupancyRate") + " " + job.occupancyRate,
        title: job.title,
        type: job.jobType?.map(type => type.title),
        excerpt,
        city,
        state,
        image,
      }
    })

    return shuffle(jobs)
  }, [allCollectionJobs.nodes, t])

  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition: buttonPosition?.value,
        anchor,
      }}
    >
      <JobOffersModule contents={shuffled} searchIndex={siteSearchIndex} />
    </Section>
  )
}

// PropTypes.shape({
//   suptitle: PropTypes.string,
//   title: PropTypes.string.isRequired,
//   excerpt: PropTypes.string.isRequired,
//   image: PropTypes.element.isRequired,
//   to: PropTypes.string,
// })

export { Jobs }
